import React from "react";
import { useStyles } from "./styles";

interface Props {
  children?: React.ReactNode;
}

const ModalFormPrimaryActions = ({ children }: Props) => {
  const classes = useStyles();
  return <div className={classes.primaryActions}>{children}</div>;
};

export default ModalFormPrimaryActions;
